import React, { Component } from 'react';
import './CheckboxWithLabel.scss';

const CheckboxWithLabel = ({ handleClick, id, isChecked, labelText, name }) => {
    return (
        <div className="checkbox__wrapper">
            <input
                checked={isChecked}
                className="checkbox"
                onClick={handleClick}
                id={id}
                name={name}
                type="checkbox"
                value={name}
            />

            <label className="checkbox__label" htmlFor={id}>
                {labelText}
            </label>
        </div>
    );
};

export default CheckboxWithLabel;


// WEBPACK FOOTER //
// ./application/components/CheckboxWithLabel/CheckboxWithLabel.jsx